// extracted by mini-css-extract-plugin
export var item = "item-module--item--beZ5X";
export var item_link = "item-module--item_link--1h30y";
export var iconsWrap_arrow = "item-module--iconsWrap_arrow--35Mq4";
export var title = "item-module--title--ERs44";
export var iconsWrap = "item-module--iconsWrap--1fWeW";
export var description = "item-module--description--WLH-4";